import React from 'react';
import '../App.css';

function Footer() {
    return (
        <footer>
            <p>&copy; 2024 [Your Name]. All rights reserved.</p>
        </footer>
    );
}

export default Footer;
